var boostPFSInstantSearchConfig={search:{}};!function(){BoostPFS.inject(this),SearchInput.prototype.customizeInstantSearch=function(e,t,r){},SearchInput.prototype.beforeInit=function(e){jQ(".live-search-form, .site-header-search-form").removeAttr("data-live-search-form").removeAttr("data-live-search-flydown"),jQ('input[name="q"]').removeAttr("data-live-search-input"),jQ(".search-flydown").hide(),jQ("button.site-header-search-button.button-primary").prop("type","submit"),jQ("button.live-search-button.button-primary").prop("type","submit"),jQ(document).ready((function(){jQ(".live-search-form, .site-header-search-form").off(".search-form"),"undefined"!=typeof bcHeaderSearch&&bcHeaderSearch.unload()}))}}();
//# sourceMappingURL=/s/files/1/0553/3171/7282/t/162/assets/boost-pfs-instant-search.js.map?v=1637327811

var boostPFSInstantSearchConfig = { search: {} };
!(function () {
    BoostPFS.inject(this),
        (SearchInput.prototype.customizeInstantSearch = function (e, t, r) {}),
        (SearchInput.prototype.beforeInit = function (e) {
            jQ(".live-search-form, .site-header-search-form").removeAttr("data-live-search-form").removeAttr("data-live-search-flydown"),
                jQ('input[name="q"]').removeAttr("data-live-search-input"),
                jQ(".search-flydown").hide(),
                jQ("button.site-header-search-button.button-primary").prop("type", "submit"),
                jQ("button.live-search-button.button-primary").prop("type", "submit"),
                jQ(document).ready(function () {
                    jQ(".live-search-form, .site-header-search-form").off(".search-form"), "undefined" != typeof bcHeaderSearch && bcHeaderSearch.unload();
                });
        });


        (InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
        		this.prepareSuggestionProductPriceData();
        		// Check on sale
        		var onSale = this.data.compare_at_price_min > this.data.price_min;
        		// Format price
        		var price = Utils.formatMoney(this.data.price_min);
        		var compareAtPrice = '';
                var price_html = Utils.formatMoney(this.data.price_min);
                var price_format = Utils.formatMoney(this.data.price_min).split('.');
                var price_min = price_format[0];
                var price_min_decimals = price_format[1];
        		if (this.data && this.data.compare_at_price_min) {
        			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);	
        		}
                price_min = price_min + '.<sup>' + price_min_decimals + '</sup>';
        		
        		// Build Price
        		var result = '';
        		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
        			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
        				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
        			} else {
        				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        			}
        		}
              
              	var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
              	if (priceVaries) {
                  	price = 'From ' + price_min;
                }
        		return result
        			.replace(/{{regularPrice}}/g, price_min)
        			.replace(/{{compareAtPrice}}/g, compareAtPrice);
         }); 


  InstantSearchApi.beforeCall = function (searchTerm) {
    /* Change the params before calling api */
    Globals.instantSearchQueryParams.h_options = ["hidden-search"];
  };
  
})();
//# sourceMappingURL=/s/files/1/0553/3171/7282/t/162/assets/boost-pfs-instant-search.js.map?v=1637327811
